import eventBus from "../../../../main";
import apiServices from "../../../../../services/apiServices";

export default {
  state: {
    updateProduct: {
      nmb: "",
      productName: "",
      productPrice: ""
    },
    deleteProduct: {
      status: null
    }
  },
  mutations: {
    // SET_SERVICE_PRODUCT(state, value) {
    //     state.selectProduct.serviceProduct = value;
    // }
    SET_UP_REALTIME_PRODUCT(state, value) {
      state.updateProduct.nmb = value.nmb;
      state.updateProduct.productName = value.productName;
      state.updateProduct.productPrice = value.productPrice;
    },
    SET_EVENT_DELETE_PRODUCT(state, value) {
      state.deleteProduct.status = value;
    }
  },
  actions: {
    upRealTime(context, payload) {
      context.commit("SET_UP_REALTIME_PRODUCT", payload);
    },

    clearEventDeleteProduct(context) {
      context.commit("SET_EVENT_DELETE_PRODUCT", null);
    },

    createProduct(context, payload) {
      apiServices
        .createProducts(payload)
        .then(function(response) {
          //|| response.status === 300
          if (response.status === 200 || response.status === 201) {
            let payload = {
              color: "success",
              text: "Produto criado com sucesso",
              errorLogin: true,
              right: "center",
              top: "top"
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          } else {
            let payload = {
              color: "error",
              text: "Ups! Seu pedido não foi processado",
              errorLogin: true,
              right: "center",
              top: "top"
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function(error) {
          let payload = {
            color: "error",
            text: "Ups! Seu pedido não foi processado",
            errorLogin: true,
            right: "center",
            top: "top"
          };
          if (error == "Error: Network Error") {
            return eventBus.$emit("openInfo", {
              color: "error",
              text: "Verifique a sua conexão com a internet",
              errorLogin: true,
              right: "center",
              top: "top"
            }); // emit the event to the bus
          }

          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          eventBus.$emit("openSpin", false);
        });
    },

    //Edit Product
    editProduct(context, payload) {
      apiServices
        .editProducts(payload.productUUID, payload)
        .then(function(response) {
          //|| response.status === 300
          if (response.status === 200 || response.status === 201) {
            let payload = {
              color: "success",
              text: "Produto actualizado com sucesso",
              errorLogin: true,
              right: "center",
              top: "top"
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus

            const value = {
              nmb: context.getters.getUpdateNmb,
              productName: context.getters.getUpdateName,
              productPrice: context.getters.getUpdatePrice
            };
            eventBus.$emit("updateRealtimeProduct", value);
          } else {
            let payload = {
              color: "error",
              text: "Ups! Seu pedido não foi processado",
              errorLogin: true,
              right: "center",
              top: "top"
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function(error) {
          let payload = {
            color: "error",
            text: "Ups! Seu pedido não foi processado",
            errorLogin: true,
            right: "center",
            top: "top"
          };
          if (error == "Error: Network Error") {
            return eventBus.$emit("openInfo", {
              color: "error",
              text: "Verifique a sua conexão com a internet",
              errorLogin: true,
              right: "center",
              top: "top"
            }); // emit the event to the bus
          }

          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          eventBus.$emit("openSpin", false);
        });
    },

    //Edit Product
    deleteProduct(context, payload) {
      apiServices
        .deleteProducts(payload.productUUID)
        .then(function(response) {
          //|| response.status === 300
          if (response.status === 200 || response.status === 201) {
            let obj = response.data;
            if (obj.code === 200 && obj.type === "success") {
              let payload = {
                color: "success",
                text: "Produto apagado com sucesso",
                errorLogin: true,
                right: "center",
                top: "top"
              };
              context.commit("SET_EVENT_DELETE_PRODUCT", true);
              eventBus.$emit("openInfo", payload); // emit the event to the bus
            } else {
              let payload = {
                color: "error",
                text: "Ups! Seu pedido não foi processado",
                errorLogin: true,
                right: "center",
                top: "top"
              };
              eventBus.$emit("openInfo", payload); // emit the event to the bus
            }
          } else {
            let payload = {
              color: "error",
              text: "Ups! Seu pedido não foi processado",
              errorLogin: true,
              right: "center",
              top: "top"
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function(error) {
          let payload = {
            color: "error",
            text: "Ups! Seu pedido não foi processado",
            errorLogin: true,
            right: "center",
            top: "top"
          };
          if (error == "Error: Network Error") {
            return eventBus.$emit("openInfo", {
              color: "error",
              text: "Verifique a sua conexão com a internet",
              errorLogin: true,
              right: "center",
              top: "top"
            }); // emit the event to the bus
          }
          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          eventBus.$emit("openSpin", false);
        });
    }
  },
  getters: {
    getUpdateNmb(state) {
      return state.updateProduct.nmb;
    },
    getUpdateName(state) {
      return state.updateProduct.productName;
    },
    getUpdatePrice(state) {
      return state.updateProduct.productPrice;
    },
    getEventDeleteProduct(state) {
      return state.deleteProduct.status;
    }
  }
};
